import type { OnboardingDocument } from "./onboarding-document.model";

export enum BusinessImportSource {
  FleetCard = "FleetCard",
}


export enum BusinessStructure {
  CORPORATION = 'CORPORATION',
  SOLE_PROPRIETORSHIP = 'SOLE_PROPRIETORSHIP',
  LLC = 'LLC'
}

export type BusinessStructureLabel = 'Sole proprietor' | 'Corporation' | 'LLC';

export const BusinessStructureLabels: Record<BusinessStructure, BusinessStructureLabel> = {
  [BusinessStructure.SOLE_PROPRIETORSHIP]: 'Sole proprietor',
  [BusinessStructure.CORPORATION]: 'Corporation',
  [BusinessStructure.LLC]: 'LLC',
};

export type Business = {
  address: string;
  city: string;
  documents: OnboardingDocument[];
  dot: string;
  ein?: string;
  id: string;
  importedFrom?: BusinessImportSource;
  name: string;
  phoneNumber: string;
  state: string;
  zip: string;
  countryCode: string;
  structure?: BusinessStructure;
  ssn?: string;
}
